module.exports = __webpack_public_path__ + "img/blog2.44656071.jpeg";